import {format} from 'date-fns'
import {useEffect, useState} from 'react'
import {BookingBookingPostBody} from '../../../services/booking/types'
import {EmployeeDetailsResponse} from '../../../types/employee'
import {parseQueryString} from './queryStringParser'


export const useBookingData = (employeeDetails?: EmployeeDetailsResponse) => {
  const [bookingData, setBookingData] = useState<BookingBookingPostBody | null>(null)

  useEffect(() => {
    const data = parseQueryString() as BookingBookingPostBody
    const date = new Date()

    // Set common fields
    data.createdByDate = format(date, 'yyyy-MM-dd HH:mm:ss')
    data.fromDate = format(date, 'yyyy-MM-dd')
    data.fromTime = '00:00:00'
    data.toDate = format(date, 'yyyy-MM-dd')
    data.toTime = '23:59:59'

    // Add employee details if available
    if (employeeDetails) {
      data.employeeId = employeeDetails.employeeId
      data.employeeName = `${employeeDetails.employeeForename} ${employeeDetails.employeeSurname}`
      data.createdByEmployeeId = employeeDetails.employeeId
    }

    setBookingData(data)
  }, [employeeDetails])

  return bookingData
}
